// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import './assets/font-icon/iconfont.js' // 最新版字体文件
import './assets/font-icon/iconfont.css'
import 'mint-ui/lib/style.css' // mint-ui 的css
import './assets/style/reset.styl' // 最新版字体文件
import './util/rem' // rem 适配文件
import AppHelper from '@/util/appHybrid' // 内嵌 app
import Unil from './util/index'
import Statistics from './util/Statistics'
import {
  _HttpClient
} from '@/service/http.client.js'
import MintUI from 'mint-ui' // mint-ui 的js
import Calendar from 'vue2-datepick' // 日历控件
import VueAwesomeSwiper from 'vue-awesome-swiper' // 上下轮播插件js
import 'swiper/dist/css/swiper.css' // 上下轮播插件css
import 'babel-polyfill'
import VueClipboard from 'vue-clipboard2'
import Vant from 'vant'
import 'vant/lib/index.css'
import config from '../config/env.js'
import VConsole from 'vconsole'

if (process.env.NODE_ENV == 'test') {
  // const vConsole = new VConsole()
}
console.log('Unil', Unil)
Vue.use(VueClipboard)
Vue.use(Vant)
const {
  baseUrl,
  baseUrl1
} = config
Vue.use(AppHelper)
Vue.use(Unil)
Vue.use(Statistics)
Vue.use(MintUI)
Vue.use(Calendar)
Vue.use(VueAwesomeSwiper /* { default global options } */ )

Vue.config.productionTip = false
window['openJesongChat'] = function () {
  let yiliaourl = 'https://aoji.easyliao.com/live/chat.do?g=5660&c=3801'
  let _userAgent = navigator.userAgent
  // smart-counselor/android         smart-counselor/ios
  if (_userAgent.indexOf('smart-counselor') !== -1) {
    AppHelper.AppHelper.openWebView({
      url: yiliaourl,
      title: '澳际教育',
      showShare: false
    })
  } else {
    window.location.href = yiliaourl
  }
}

window.onload = function () {
  try {
    // 如果在微信浏览器中执行该代码，解决微信中复制动态链接
    //因语言测评新id所以需要修改
    if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      console.log('begin request wechat')
      // 注入wx js sdk
      _HttpClient.get(baseUrl + `/wechat/jsApiParam?url=${escape(window.location.href.split('#')[0])}&type=1`, {}).then(res => {
        localStorage.setItem("appid", res.body.appid)
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.body.appid, // 必填，公众号的唯一标识
          timestamp: res.body.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
          signature: res.body.signature, // 必填，签名
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'hideMenuItems', 'hideAllNonBaseMenuItem', 'showMenuItems'] // 必填，需要使用的JS接口列表
        })
        wx.ready(function () {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          console.log('wx ready, begin check js api')
          wx.checkJsApi({
            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              console.log(res)
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            },
            fail: function (res) {
              console.error(res)
            },
            complete: function (res) {
              console.log(res)
            }
          })
          setTimeout(function () {
            wx.hideAllNonBaseMenuItem()
            wx.showMenuItems({
              menuList: ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:favorite", "menuItem:share:QZone"]
            })
          }, 400)
        })
      })
    }
  } catch (error) {

  }
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js